import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import "swiper/swiper.min.css";
import Style from "./index.module.css";
import Img from "../../../components/Image";
SwiperCore.use([Pagination, Autoplay]);

const Carousel = () => {
  const contentData = [
    {
      heading: "United States",
      imagesrc1:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Flocation%20pin.webp?alt=media&token=f5855445-b17a-4010-84b0-c44a4ee4521f",
      description:
        "1968 S Coast Hwy, Suite 5011, Laguna Beach, California, USA 9265.",
      imagesrc2:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Fphone.webp?alt=media&token=df2abe62-8cc2-46a5-addb-57895146889d",
      num: "+1 (415) 624 7431",
      imagesrc3:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Fenvelope.webp?alt=media&token=ec5925dc-391f-4bed-95e6-6e51817304c2",
      mail: "info@nexusconnects.ai",
    },
    {
      heading: "India",
      imagesrc1:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Flocation%20pin.webp?alt=media&token=f5855445-b17a-4010-84b0-c44a4ee4521f",
      description: "5th Floor, NAVAYUGA VIZVA, GachiBowli, Hyderabad 500032.",
      imagesrc2:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Fphone.webp?alt=media&token=df2abe62-8cc2-46a5-addb-57895146889d",
      num: "+91 (402) 980 0716",
      imagesrc3:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Fenvelope.webp?alt=media&token=ec5925dc-391f-4bed-95e6-6e51817304c2",
      mail: "info@nexusconnects.ai",
    },
    {
      heading: "Singapore",
      imagesrc1:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Flocation%20pin.webp?alt=media&token=f5855445-b17a-4010-84b0-c44a4ee4521f",
      description:
        "11 Woodlands Close #07-13, Woodlands 11, Singapore (737853).",
      imagesrc2:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Fphone.webp?alt=media&token=df2abe62-8cc2-46a5-addb-57895146889d",
      num: "+65 6587 4666",
      imagesrc3:
        "https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2Fcontact%2Fenvelope.webp?alt=media&token=ec5925dc-391f-4bed-95e6-6e51817304c2",
      mail: "info@nexusconnects.ai",
    },
  ];

  const [activeSlide, setActiveSlide] = useState(0);

  const handleSlideChange = (swiper) => {
    setActiveSlide(swiper.realIndex);
  };

  return (
    <div className={Style.mapcontlocations}>
      <div className={Style.maplocationshead}>Our Locations</div>
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        
        pagination={{
          clickable: true,
          loop: true,
        }}
        loop
        autoplay={{ delay: 4000 }}
        onSlideChange={handleSlideChange}
      >
        {contentData.map((content, index) => (
          <SwiperSlide key={index}>
            <div className={Style.mapcontent1}>
              <div className={Style.mapcontent1section1}>
                <Img src={content.imagesrc1} />
              </div>

              <div className={Style.mapcontent1section2}>
                <div className={Style.section2head}>{content.heading}</div>
                <div className={Style.section2desc}>{content.description}</div>

                <div className={Style.section2bottom}>
                  <div className={Style.logo}>
                    <Img src={content.imagesrc2} />
                  </div>
                  <div className={Style.num}>{content.num}</div>
                </div>

                <div className={Style.section2bottom}>
                  <div className={Style.logo}>
                    <Img src={content.imagesrc3} />
                  </div>
                  <div>{content.mail}</div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="pagination-dotsemployee">
        {contentData.map((_, index) => (
          <div
            key={index}
            className={`dotemployee ${index === activeSlide ? "active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;